<!--
 * @Author: OnismYY
 * @Description: logo
-->
<template>
  <div>
    <!-- href="https://modao.cc/proto/E5JAgAi0s3bmq4kuru3t1A/sharing?view_mode=device&screen=rbpTtkYfjtWK26lkF&canvasId=rcTtkYfjU1befwR2sxvd4s&from=sharing"
      target="_blank" -->
    <a>
      <v-card
        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 25px 15px -20px"
        height="64"
        class="d-flex align-center justify-center"
      >
        <img
          v-if="customizeTheme.darkTheme"
          :width="customizeTheme.isMobile ? '100' : '160'"
          src="@/assets/logo_dark.png"
          alt=""
        />
        <img v-else :width="customizeTheme.isMobile ? '100' : '160'" src="@/assets/logo_light.png" alt="" />
      </v-card>
    </a>
  </div>
</template>

<script setup>
import { useCustomizeThemeStore } from '@/stores/customize-theme'

const customizeTheme = useCustomizeThemeStore()
</script>

<style lang="scss" scoped></style>
